module.exports = __webpack_public_path__ + "static/media/joffre-10.cca6dbc3.jpg";